import { render } from "./EditBook.vue?vue&type=template&id=0fffb298"
import script from "./EditBook.vue?vue&type=script&lang=js"
export * from "./EditBook.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Products/EditBook.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fffb298"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fffb298', __exports__)) {
    api.reload('0fffb298', __exports__)
  }
  
  module.hot.accept("./EditBook.vue?vue&type=template&id=0fffb298", () => {
    api.rerender('0fffb298', render)
  })

}


export default __exports__